<template>
  <span :class="style.heading">Email</span>
  <div :class="style.inputs">
    <InputStyle
      size="M"
      placeholder="Введите email"
      description="Email"
      v-model="localIntegration.email"
    />
  </div>
  <div :class="style.buttons">
    <PrimaryButton
      :text="edit ? 'Сохранить' : 'Добавить интеграцию'"
      @click="saveIntegration"
    />
    <SecondaryButton
      text="Удалить"
      v-if="edit"
      :icon="trashIcon"
      @click="$emit('delete')"
    />
  </div>
</template>

<script lang="ts">
import {defineComponent} from "vue";
import style from "./settingIntegrations.module.scss";
import PrimaryButton from "@/elements/UI/button/ButtonStyle/Default/primary/PrimaryButton.vue";
import SecondaryButton from "@/elements/UI/button/ButtonStyle/Default/secondary/SecondaryButton.vue";
import trashIcon from "$images/icons/button/Name=Trash, Size=16, Tone=Default.svg";
import InputStyle from "@/elements/UI/input/Style/InputStyle.vue";

export default defineComponent({
  name: "SettingIntegrationEmail",
  components: {InputStyle, SecondaryButton, PrimaryButton},
  emits: ["delete", "closeModal"],
  props: {
    edit: {
      type: Boolean,
      default: false
    },
    integrationIndex: {
      type: Number,
      default: 0
    },
    integration: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      style,
      trashIcon,
      localIntegration: {
        email: this.integration ?? ""
      }
    };
  },
  methods: {
    saveIntegration() {
      const integration = this.getIntegration.email;

      if (!integration) return;

      if (
        this.edit &&
        this.integrationIndex >= 0 &&
        this.integrationIndex < integration.integration.length
      ) {
        integration.integration[this.integrationIndex] =
          this.localIntegration.email;
      } else {
        integration.integration.push(this.localIntegration.email);
      }

      this.$emit("closeModal");
    }
  },
  computed: {
    getIntegration() {
      return this.$integrationStore.getIntegration;
    }
  },
  watch: {
    integration: {
      immediate: true,
      deep: true,
      handler(newVal) {
        if (!newVal) return;

        this.localIntegration = {
          email: newVal || ""
        };
      }
    }
  }
});
</script>
